enum ProductStatus {
    InStock = "InStock",
    OutOfStock = "OutOfStock",
    Discontinued = "Discontinued",
}

export default ProductStatus;
